import { AllProductsResponseModel, ProductResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ProductDTO } from './dto/product.dto';
import { ProductRequest } from './dto/product.request';
import { ProductsService } from './products.service';
// const TPLinkSmartPlug = require('tplink-smartplug-node');
// let tp = new TPLinkSmartPlug("192.168.0.62");

@ApiTags('products')
@Controller('products')
export class ProductsController {
    constructor(
        private productService: ProductsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      /**
     * creates or updates a value of product
     * @param productDto product DTO
     * @returns productResponse
     */
    @Post('/createProduct')
    async createProduct(@Body() productDto:ProductDTO,isUpdate:boolean=false,@Req() request:Request): Promise<ProductResponseModel> {
        try {
         return await this.productService.createProduct(productDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(ProductResponseModel, error);
       }
     }

      /**
     * gets all the Value of products
     * @returns AllValue ProductsResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
      

    @Post('/getAllProducts')
    async getAllProducts(@Body() req?:UserRequestDto): Promise<AllProductsResponseModel> {
        try {
            return await this.productService.getAllProducts(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllProductsResponseModel, error);
        }
    }
    @Post('/getAllActiveProducts')
  async getAllActiveProducts(@Req() request: Request): Promise<AllProductsResponseModel> {
      try {
          return await this.productService.getAllActiveProducts();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllProductsResponseModel, error)
      }
  }

     /**
     * Activate Or De-Activate Value Product
     * @param getSingleProduct ProductResponseModel 
     * @returns Value Product
     */
   @Post('/activateOrDeactivateProduct')
   async activateOrDeactivateProduct(@Body() productReq: ProductRequest): Promise<ProductResponseModel> {
       try {
           return await this.productService.activateOrDeactivateProduct(productReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(ProductResponseModel, err);
       }
   }

   @Post('/getActiveProductById')
   async getActiveProductById(@Body() productReq: ProductRequest): Promise<ProductResponseModel> {
       try {
           return await this.productService.getActiveProductById(productReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(ProductResponseModel, err);
       }
   }

    /**
     * creates or updates a value of product
     * @param productDto product DTO
     * @returns productResponse
     */
     @Post('/updateProduct')
     async updateProduct(@Body() productDto:ProductDTO,@Req() request:Request): Promise<ProductResponseModel> {
         try {
          return await this.productService.createProduct(productDto,true,request);
        } catch (error) {
             return this.applicationExceptionHandler.returnException(ProductResponseModel, error);
        }
      }
    //   @Post('/smartPlugOutput')
    //   async  smartPlugOutput(): Promise<any> {
    //     tp.query().then(info => {
    //         console.log(info)
    //         console.log(info.system.get_sysinfo)
    //         if(info.system.get_sysinfo.relay_state == 0){
    //             tp.turnOn().then(onresp => {
    //                 console.log(onresp)
    //                 // resp should be { system: { set_relay_state: { err_code: 0 } } }
    //             });
    //         }else{
    //             tp.turnOff().then(offresp => {
    //                 console.log(offresp)
    //                 // resp should be { system: { set_relay_state: { err_code: 0 } } }
    //             });
    //         }
    //     })
    //     // tp.turnOn().then(resp => {
    //     //     tp.query().then(info => {
    //     //         console.log(info.relay_state)
    //     //     })
    //     //     console.log(resp)
    //     //     // resp should be { system: { set_relay_state: { err_code: 0 } } }
    //     // });
    // }

      
}
